import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { cultivatorsEventPanels } from "../assets/cultivatorsEventPanels";
import { type Post } from "../schema";

const useEventSeries = (eventSeriesID: string) => {
  const [series, setSeries] = useState<Post>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const seriesData = cultivatorsEventPanels.find((panel) => panel.title_slug === eventSeriesID);

    if (!seriesData) {
      navigate(`/404`);
      return;
    }

    setSeries(seriesData);
    setIsLoading(false);
  }, [eventSeriesID]);

  return { series, isLoading };
};

export default useEventSeries;
